<template>
<div>
    <div class="process-diagram">
       <div class="bottons">
            <div>
                <el-button type="info" plain>未开始</el-button>
                <el-button type="unassigned" >未分配</el-button>
                <el-button type="unclaimed" >待认领</el-button>
                <el-button type="primary" >进行中</el-button>
                <el-button type="warning" >快到期</el-button>
                <el-button type="success" >已完成</el-button>
                <el-button type="danger" >已延期</el-button>
            </div>
            <el-button v-if="isFullScreen" style="float:right" type="primary" icon="el-icon-rank" size="mini" @click.stop="handleFullScreen()">全屏</el-button>
        </div>
        <el-tabs v-model="tabName" type="border-card">
            <!-- 流程图 -->
            <el-tab-pane class="diagram-pane" name="first" label="流程图">
                <!-- <iframe class="diagram-page" :src="diagramUrl" frameborder="0"></iframe> -->
                <iframe id="diagramIframe" :src="diagramUrl" class="diagram-page" frameborder="0"></iframe>
            </el-tab-pane>
            <!-- 流程明细 -->
            <el-tab-pane name="second" label="流程明细">
              <ProcessSetting
                :processInstance="processInstance"
                :taskList="taskList"
                :archiveTemplateTreeList="archiveTemplateTreeList"
                :isShowTitle="false"
                @refreshProcessList="refreshProcessList"
              />
            </el-tab-pane>
        </el-tabs>
    </div>
      <!-- 显示图标 -->
      <el-dialog
          title="子流程图"
          width="80%"
          :fullscreen=true
          :visible.sync="isShowSubDiagram"
          append-to-body
          >
          <ProcessDiagram 
            ref="subDiagrams" 
            :processInstance="subInstances" 
            :taskList="subTaskList" 
            :archiveTemplateTreeList="subArchiveTemplateTreeList"
          />
      </el-dialog>
  </div>
</template>

<script>
    import ProcessSetting from './ProcessSetting';
    import ProcessDiagram from './ProcessDiagram';
    import { getProcessDiagramUrl, getProcessInstancesDetail, getAllUserTask, getArchiveTemplateTreeList } from '@/data-model';
    export default {
        components: {
            ProcessSetting,
            ProcessDiagram
        },
        data () {
            return {
                tabName: 'first',
                isFinish: false,
                oldProcessInstanceId: '',
                diagramUrl: '',
                subInstances: {},
                isShowSubDiagram: false,
                subTaskList: [],
                subArchiveTemplateTreeList: []
            };
        },
        props: {
            taskList: {
                type: Array
            },
            archiveTemplateTreeList: { // 档案模板树型列表数据
                type: Array
            },
            processInstance: {
                type: Object
            },
            isFullScreen: { // 是否全屏
                type: Boolean,
                default: false
            }
        },
        watch: {
            // 'taskList' (newVal, oldVal) {
            //     // console.log(this.oldProcessInstanceId);
            //     // console.log(this.processInstance.id);
            //     if (this.oldProcessInstanceId !== this.processInstance.id) {
            //         let url = this.getDiagramUrl();
            //         this.diagramUrl = url;
            //         this.oldProcessInstanceId = this.processInstance.id;
            //         console.log(this.diagramUrl);
            //     }
            // }
        },
        computed: {
            // diagramUrl () {
            //     return this.getDiagramUrl();
            // }
        },
        created () {
            this._initPage();
        },
        methods: {
            async _initPage () {
                this._addEventListener();
            },
            resetDiagramUrl () {
                let url = this.getDiagramUrl();
                this.diagramUrl = url;
            },
            getDiagramUrl () {
                // console.log(this.isFinish);
                let url = getProcessDiagramUrl(this.processInstance.id, this.isFinish);
                // console.log(url);
                return url;
            },
            setProcessState (isFinish) {
                this.isFinish = isFinish;
            },
            refreshProcessList () {
                this.$emit('refreshProcessList');
            },
            handleFullScreen () {
                this.$emit('handleFullScreen');
            },
            _addEventListener () {
                window.addEventListener('message', this._messageEvent);
            },
            _removeEventListener () {
                window.removeEventListener('message', this._messageEvent);
            },
            _messageEvent (e) {
                let eventData = e.data;
                // 只接收activiti推送的消息
                if (eventData.component && eventData.component === 'activiti') {
                    if (eventData.data && (eventData.data.type === 'CallActivity')) {
                        // console.log(eventData);
                        if (this.processInstance.subProcessMapping) {
                            let subProcessInstanceId = '';
                            for (var item in this.processInstance.subProcessMapping) {
                                // console.log(item);
                                if (eventData.data.id === item) {
                                    subProcessInstanceId = this.processInstance.subProcessMapping[item];
                                    break;
                                }
                            }
                            if (subProcessInstanceId) {
                                this.handelViewSubprocess(subProcessInstanceId);
                                // 调用子组件的方法
                                setTimeout(() => {
                                    // 调用子组件的方法
                                    this.$refs.subDiagrams.setProcessState(this.isFinish);
                                    this.$refs.subDiagrams.resetDiagramUrl();
                                }, 0);
                            }
                        }
                    }
                }
            },
            async handelViewSubprocess (subProcessInstanceId) {
                await this.setSubProcessViewInfo(subProcessInstanceId);
                this.isShowSubDiagram = true;
                // // setTimeout(() => {
                // // 调用子组件的方法
                // this.$refs.subDiagrams.setProcessState(this.isFinish);
                // this.$refs.subDiagrams.resetDiagramUrl();
                // // }, 0);
            },
            async setSubProcessViewInfo (subProcessInstanceId) {
                // console.log(subProcessInstanceId);
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.subInstances = await getProcessInstancesDetail(subProcessInstanceId);
                // console.log(this.subInstances);
                let tasks = await getAllUserTask(this.subInstances.id, this.subInstances.processServiceId, null, this.subInstances.deploymentId);
                // console.log(tasks);
                this.subTaskList = tasks;
                let treeList = [];
                if (this.subInstances.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: this.subInstances.archiveTemplateId});
                }
                this.subArchiveTemplateTreeList = treeList;
                loading.close();
            },
            handleCloseEleEditor (done) {
                done();
            }
        }
    };
</script>

<style lang="less">
    .process-diagram { 
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-top:-3%;
        .diagram-pane {
            flex: 1;
        }
        .diagram-page {
            // height: 700px;
            height: 1100px;
            flex: 1;
            width: 100%;
        }
        .bottons {
            display: flex;
            justify-content: space-between;
            margin: 10px 0 10px 10px;
        }
        .el-button--unassigned {
            // color: #409eff;
            // background-color: #c6e2ff;
            // border-color: #ecf5ff;
            color: #909399;
            background: #7FFFD4;
            border-color: #7FFFD4;
        }
        .el-button--unassigned:hover{
            color: #909399;
            background: #7FFFD4;
            border-color: #7FFFD4;
        }
        .el-button--unclaimed {
            color: #fff;
            background: #FF00FF;
            border-color: #FF00FF;
        }
        .el-button--unclaimed:hover{
            color: #fff;
            background: #FF00FF;
            border-color: #FF00FF;
        }
        .el-button--info.is-plain:hover{
            color: #909399;
            background: #f4f4f5;
            border-color: #d3d4d6;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/process/MyProcess/SubProcessDiagram.vue